import { getDocumentsParticipantsById } from '..';

/**
 * GET 요청자에게 받은 메시지 조회
 * @deprecated Endpoint is forwarded due to the merged on standardize-document-content
 * @see https://www.notion.so/modusign/bb8e24e723434ecc946dfecb85db5ee3#28ed5a8e75934609982c8de7fa629692
 */
export function getDocumentsParticipantsMessageFromRequester({
  documentId,
  participantId,
  workspaceId,
}: {
  documentId: string;
  participantId: string;
  workspaceId: string;
}): Promise<string | null> {
  return getDocumentsParticipantsById({ documentId, participantId, workspaceId }).then((p) =>
    p.type === 'SIGNER' ? p.message : null
  );
}
